import { ControlActivityTableRow } from "./types";

// Persisted in activity-table URLs; keep these values stable.
export const FRICTION_TYPE_FILTER_KEYS = {
    OVERDUE: "overdue",
    REJECTED: "rejected",
    REOPENED: "reopened",
} as const;

export function getFrictionTypeFilterKeys(
    row: Pick<
        ControlActivityTableRow,
        "isOverdue" | "rejectionCount" | "reopenCount"
    >
): string[] {
    return [
        ...(row.isOverdue ? [FRICTION_TYPE_FILTER_KEYS.OVERDUE] : []),
        ...(row.rejectionCount > 0 ? [FRICTION_TYPE_FILTER_KEYS.REJECTED] : []),
        ...(row.reopenCount > 0 ? [FRICTION_TYPE_FILTER_KEYS.REOPENED] : []),
    ];
}
